import { createStore } from "vuex";
import { IRootState } from "@/interfaces/store/IRootState";

const store = createStore<IRootState>({});

// HMR safety: `vuex-module-decorators` with `dynamic: true` re-runs
// `store.registerModule` on every hot re-import. Vuex 4 then stacks
// mutation/action handlers and resets the namespace state, which tears
// the UI. In production this block is dead code (no `import.meta.hot`).
if (import.meta.hot) {
  const originalRegister = store.registerModule.bind(store);
  store.registerModule = ((path: any, mod: any, options?: any) => {
    const name = Array.isArray(path) ? path[0] : path;
    if (store.hasModule(name)) return;
    return originalRegister(path, mod, options);
  }) as typeof store.registerModule;
}

export default store;
